module.exports = __webpack_public_path__ + "img/404.d7c4d73f.jpg";